export enum AcknowledgmentType {
  AGENT_TRANSFER = 1,
  AGENT_LEAVING = 2,
}